import { EditPaymentFormValues } from './Page'
import { pipe, pick } from 'ramda'

export const transform = pipe(pick(['iban', 'bic', 'priority', 'name'])) as (
  data: any,
) => EditPaymentFormValues
